import React from 'react';
import getBlock from './get-block';
import Column from './column';

const getBlockForSection = ({ __typename: typename, ...block }) => {
  if (typename === 'STRAPI__COMPONENT_PAGEBUILDER_COLUMN') {
    return <Column key={block.id} {...block} />;
  }
  return getBlock({ __typename: typename, ...block });
};

export default getBlockForSection;
